module.exports = __webpack_public_path__ + "img/donut_large.87a24e10.svg";